import type { MaterialMobileState } from "~/store/materialMobileSlice";

import { CACHED_HISTORY_SCHEMA_VERSION } from "~/store/materialMobileSlice";

const migrateLegacyCachedHistory = (outboundState: MaterialMobileState): MaterialMobileState => {
	const isCurrentSchema = outboundState.cachedHistorySchemaVersion === CACHED_HISTORY_SCHEMA_VERSION;
	return {
		...outboundState,
		cachedHistory: isCurrentSchema ? (outboundState.cachedHistory ?? []) : [],
		cachedHistorySchemaVersion: CACHED_HISTORY_SCHEMA_VERSION
	};
};

export default migrateLegacyCachedHistory;
